export default __webpack_public_path__ + "static/media/assessment-page-background.7235308a.png";